export const initialState = {
    isLoading: false
};

export default function receiving() {

}

